import { render, staticRenderFns } from "./FormsTable.vue?vue&type=template&id=5d55f6ab&scoped=true&"
import script from "./FormsTable.vue?vue&type=script&lang=ts&"
export * from "./FormsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55f6ab",
  null
  
)

export default component.exports